import {
  FETCHING_ALL_WORKSPACES_SUCCEEDED,
  FETCHING_ALL_WORKSPACES_FAILED,
  FETCHING_ALL_WORKSPACES,
  FETCHING_STORYBOARDS_REQUEST,
  FETCHING_STORYBOARDS_SUCCEEDED,
  FETCHING_STORYBOARDS_FAILED,
  ACTIVATING_CLEVERSTORY_WORKSPACE,
  ACTIVATING_CLEVERSTORY_WORKSPACE_FAILED,
  ACTIVATING_CLEVERSTORY_WORKSPACE_SUCCEEDED,
  FETCHING_ACTIVATED_WORKSPACES,
  FETCHING_ACTIVATED_WORKSPACES_SUCCEEDED,
  FETCHING_ACTIVATED_WORKSPACES_FAILED,
  DELETING_DATA_SOURCE_FAILED,
  FETCHING_PAGES_FROM_STORYBOARD,
  FETCHING_PAGES_FROM_STORYBOARD_FAILED,
  FETCHING_PAGES_FROM_STORYBOARD_SUCCEEDED,
  CREATING_PAGE_FROM_STORYBOARD,
  CREATING_PAGE_FROM_STORYBOARD_SUCCEEDED,
  CREATING_PAGE_FROM_STORYBOARD_FAILED,
  INVALIDATE_CLEVERSTORY_PAGE_CREATION
} from 'src/legacy/redux/actions/actionTypes';
import _ from 'lodash';

import { DELETING_DATA_SOURCE, DELETING_DATA_SOURCE_SUCCEEDED, } from 'src/redux/actions/actionTypes';
const initialState = {

  allWorkspaces: {
    loading: false,
    error: null,
    items: []
  }
}

function cleverstoryReducer(state = initialState, action) {

  switch (action.type) {

    case FETCHING_ALL_WORKSPACES:
      return Object.assign({}, state, {
        ...state,
        allWorkspaces: {
          ..._.get(state, "allWorkspaces", {}),
          loading: true,
          error: null
        },
      });

    case FETCHING_ALL_WORKSPACES_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        allWorkspaces: {
          loading: false,
          error: null,
          items: _.get(action, "payload", [])
        },
      });

    case FETCHING_ALL_WORKSPACES_FAILED:
      return Object.assign({}, state, {
        ...state,
        allWorkspaces: {
          ..._.get(state, "allWorkspaces", {}),
          loading: false,
          error: action.payload
        },
      });

    case FETCHING_STORYBOARDS_REQUEST:
      return Object.assign({}, state, {
        ...state,
        storyboards: {
          ..._.get(state, "storyboards", {}),
          [action.workspaceId]: {
            ..._.get(state, `storyboards[${action.workspaceId}]`, {}),
            loading: true,
            error: null,

          }
        },
      });

    case FETCHING_STORYBOARDS_SUCCEEDED:{
      let items = [];
      const currentPage = _.get(action, "payload.currentPage", 0);
      const records = _.get(action, "payload.records", [])
      const totalPages = _.get(action, "payload.totalPages", 0);
  
      if (currentPage === 0) {
        items = records
      }
      else {
        items = [..._.get(state, `storyboards[${action.workspaceId}].items`), ...records];
      }
  
      return Object.assign({}, state, {
        ...state,
        storyboards: {
          ...state.storyboards,
          [action.workspaceId]: {
            loading: false,
            error: null,
            currentPage,
            totalPages,
            totalRecordsCount: _.get(action, "payload.totalRecordsCount", 0),
            items
          }
        },
      });
    }


    case FETCHING_STORYBOARDS_FAILED:
      return Object.assign({}, state, {
        ...state,
        storyboards: {
          ..._.get(state, "storyboards", {}),
          [action.workspaceId]: {
            loading: false,
            error: action.payload
          }
        },
      });

    case FETCHING_PAGES_FROM_STORYBOARD:
      return Object.assign({}, state, {
        ...state,
        pages: {
          ..._.get(state, "pages", {}),
          [action.storyboardId]: {
            ..._.get(state, `pages[${action.storyboardId}]`),
            loading: true,
            error: null
          }
        },
      })


    case FETCHING_PAGES_FROM_STORYBOARD_SUCCEEDED:{
      let items = []
  
      const pagesCurrentPage = _.get(action, "payload.currentPage", 0);
      if (pagesCurrentPage === 0) {
        items = _.get(action, "payload.records", [])
      }
      else {
        items = [..._.get(state, `pages[${action.storyboardId}].items`, []), ..._.get(action, "payload.records", [])]
      }
  
      return Object.assign({}, state, {
        ...state,
        pages: {
          ..._.get(state, "pages", {}),
          [action.storyboardId]: {
            loading: false,
            error: null,
            items: items,
            currentPage: pagesCurrentPage,
            totalPages: _.get(action, "payload.totalPages", 0),
          }
        },
      })
    }



    case FETCHING_PAGES_FROM_STORYBOARD_FAILED:
      return Object.assign({}, state, {
        ...state,
        pages: {
          ..._.get(state, "pages", {}),
          [action.storyboardId]: {
            ..._.get(state, `pages[${action.storyboardId}]`),
            loading: false,
            error: action.payload,
          }
        },
      })



    case ACTIVATING_CLEVERSTORY_WORKSPACE:
      return Object.assign({}, state, {
        ...state,
        workspace: {
          [action.workspaceId]: {
            activating: true,
            activated: false,
            error: null,
            item: null
          }
        }
      })

    case ACTIVATING_CLEVERSTORY_WORKSPACE_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        workspace: {
          [action.workspaceId]: {
            activating: false,
            activated: true,
            error: null,
            item: action.payload
          }
        }
      })

    case ACTIVATING_CLEVERSTORY_WORKSPACE_FAILED:
      return Object.assign({}, state, {
        ...state,
        workspace: {
          [action.workspaceId]: {
            activating: false,
            activated: false,
            error: action.payload,
            item: null
          }
        }
      })

    case FETCHING_ACTIVATED_WORKSPACES:
      return Object.assign({}, state, {
        ...state,
        activatedWorkspaces: {
          ...state.activatedWorkspaces,
          loading: true,
          error: null,
        }
      })

    case FETCHING_ACTIVATED_WORKSPACES_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        activatedWorkspaces: {
          loading: false,
          error: null,
          items: action.payload
        }
      })

    case FETCHING_ACTIVATED_WORKSPACES_FAILED:
      return Object.assign({}, state, {
        ...state,
        activatedWorkspaces: {
          ...state.activatedWorkspaces,
          loading: false,
          error: action.payload,
        }
      })

    case DELETING_DATA_SOURCE:
      return Object.assign({}, state, {
        ...state,
        deactivatingWorkspace: {
          deactivating: true,
          deactivated: false,
          error: null
        }
      })

    case DELETING_DATA_SOURCE_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        deactivatingWorkspace: {
          deactivating: false,
          deactivated: true,
          error: null
        }
      })

    case DELETING_DATA_SOURCE_FAILED:
      return Object.assign({}, state, {
        ...state,
        deactivatingWorkspace: {
          deactivating: false,
          deactivated: false,
          error: action.payload
        }
      })

    case CREATING_PAGE_FROM_STORYBOARD:
      return Object.assign({}, state, {
        ...state,
        creatingPage: {
          ..._.get(state, "creatingPage"),
          [action.storyboardId]: {
            ..._.get(state, `creatingPage[${action.storyboardId}]`),
            [action.pageId]: {
              creating: true,
              created: false,
              error: null
            }
          },
          creating: true,
          created: false,
          error: null,
          item: null
        }
      })

    case CREATING_PAGE_FROM_STORYBOARD_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        creatingPage: {
          ..._.get(state, "creatingPage"),
          [action.storyboardId]: {
            ..._.get(state, `creatingPage[${action.storyboardId}]`),
            [action.pageId]: {
              creating: false,
              created: true,
              error: null,
              item: action.payload
            }
          },
          creating: false,
          created: true,
          error: null,
          item: action.payload
        }
      })

    case CREATING_PAGE_FROM_STORYBOARD_FAILED:
      return Object.assign({}, state, {
        ...state,
        creatingPage: {
          ..._.get(state, "creatingPage"),
          [action.storyboardId]: {
            ..._.get(state, `creatingPage[${action.storyboardId}]`),
            [action.pageId]: {
              creating: false,
              created: false,
              error: action.payload
            }
          },
          creating: false,
          created: false,
          error: action.payload,
          item: null
        }
      })

    case INVALIDATE_CLEVERSTORY_PAGE_CREATION:
      return Object.assign({}, state, {
        ...state,
        creatingPage: {
          creating: false,
          created: false,
          error: null,
          item: null
        }
      })

    default:
      return state;

  }

}

export { cleverstoryReducer };